import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import type { OutboxSummary } from "@shared/modules/x-messagerie";
import { Card } from "../../../core/components/ui/card";
import { getSummary } from "../lib/api";

type State = { kind: "loading" } | { kind: "failed" } | { kind: "ready"; summary: OutboxSummary };

/** Messagerie du jour : envoyés, en attente, échecs — et le mode simulation. */
export function MessagerieWidget() {
  const [state, setState] = useState<State>({ kind: "loading" });

  useEffect(() => {
    getSummary()
      .then((summary) => setState({ kind: "ready", summary }))
      .catch(() => setState({ kind: "failed" }));
  }, []);

  return (
    <Card
      title="Messagerie"
      subtitle="Textos et courriels envoyés aux clients."
      actions={<Link to="/messages">Ouvrir la boîte d'envoi</Link>}
    >
      {state.kind === "loading" ? (
        <p className="messagerie-widget__empty">Chargement…</p>
      ) : state.kind === "failed" ? (
        <p className="messagerie-widget__empty">Messagerie indisponible pour l'instant.</p>
      ) : (
        <>
          <dl className="messagerie-widget__stats">
            <div className="messagerie-widget__stat">
              <dt className="messagerie-widget__label">Envoyés aujourd'hui</dt>
              <dd className="messagerie-widget__value">{state.summary.sentToday}</dd>
            </div>
            <div className="messagerie-widget__stat">
              <dt className="messagerie-widget__label">En attente</dt>
              <dd className="messagerie-widget__value">{state.summary.pending}</dd>
            </div>
            <div className={`messagerie-widget__stat${state.summary.failed > 0 ? " messagerie-widget__stat--alert" : ""}`}>
              <dt className="messagerie-widget__label">Échecs</dt>
              <dd className="messagerie-widget__value">{state.summary.failed}</dd>
            </div>
          </dl>
          {!state.summary.smsConfigured || !state.summary.emailConfigured ? (
            <p className="messagerie-widget__note">
              Mode simulation
              {!state.summary.smsConfigured && !state.summary.emailConfigured
                ? " (SMS et courriel)"
                : !state.summary.smsConfigured
                  ? " (SMS)"
                  : " (courriel)"}{" "}
              : les messages sont stockés sans être transmis.
            </p>
          ) : null}
        </>
      )}
    </Card>
  );
}
